// Explicit choices win; otherwise use a still, compact portrait on touch and
// narrow screens. Resizing never writes a preference over the user's choice.
export function portraitAppearance(appearance) {
    if (appearance) return appearance === "portrait"
    return window.matchMedia("(max-width: 1023.98px), (pointer: coarse)").matches
}
